var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useRef } from "react";
import styled from "styled-components"; // tslint:disable-line
import { Link, Spinner } from "@atlassiansox/microscopekit";
import { Code, CodeBlock } from "@atlaskit/code";
import { CenteredMessage, deploymentUrlFor } from "./utils";
import { useFetchHandler, usePanelLoadDetector, useContextHandlers, } from "./hooks";
var failMessage = function (panelId, envType) {
    var url = deploymentUrlFor(panelId, envType);
    var messages = {
        local: (React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Did you forget to run a local dev server at ",
                url,
                "?"),
            React.createElement("p", null, "If you are running a server and are still seeing this message, try importing the following line on your entry js/ts file."),
            React.createElement("p", null,
                React.createElement(CodeBlock, { showLineNumbers: false, language: "javascript", text: "import from \"@atlassiansox/microscope-panel-utils\"" })))),
        staging: (React.createElement(React.Fragment, null,
            "We couldn't find any deployments of this panel in a staging environment. If you are an admin of this panel, You can deploy your panel assets with",
            " ",
            React.createElement(Code, { language: "text", text: "atlas microscopedev panel deploy -n " + panelId + " -d my/content/dir" }),
            ".")),
        prod: (React.createElement(React.Fragment, null,
            React.createElement("p", null, "We couldn't find any deployments of this panel in a prod environment. If you want to talk to the production endpoints of your service you must deploy your panel to a sox environment via bamboo/bitbucket pipeline with the command"),
            React.createElement("p", null,
                React.createElement(CodeBlock, { showLineNumbers: false, language: "text", text: "atlas microscopedev panel deploy -n " + panelId + " -e prod -d my/content/dir" })),
            React.createElement("p", null, "If you are an admin of the panel, you can allow a bamboo/bitbucket pipeline identity to be able to push your assets to production using the command"),
            React.createElement("p", null,
                React.createElement(CodeBlock, { showLineNumbers: false, language: "text", text: "atlas microscopedev panel grant -n " + panelId + " -i deployment-bamboo:MY-PROJECT-KEY" })),
            React.createElement("p", null,
                "Here",
                " ",
                React.createElement(Code, { language: "text", text: "deployment-bamboo:MY-PROJECT-KEY" }),
                " ",
                "refers to the bamboo project name/prefix that will be deploying the assets. For bitbucket pipelines, it should look something like",
                " ",
                React.createElement(Code, { language: "text", text: "bitbucket-pipelines:ownerId:containerId" })),
            React.createElement("p", null,
                "For more details, please refer to",
                " ",
                React.createElement(Link, { to: "http://go/microscope-panel" }, "Microscope Panel documentation")))),
    };
    return messages[envType];
};
var IFrame = styled.iframe(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n"], ["\n  width: 100%;\n  height: 100%;\n"])));
var iframePolicies = [
    "allow-scripts",
    "allow-same-origin",
    "allow-downloads",
    "allow-modals",
    "allow-forms",
    "allow-popups",
].join(" ");
export var PanelContent = function (props) {
    var serviceId = props.service.id;
    var panelId = props.panel.id;
    var env = props.env;
    var deploymentSource = props.deploymentSource;
    var panelUrl = deploymentUrlFor(panelId, deploymentSource);
    var loadStatus = usePanelLoadDetector(panelId, deploymentSource);
    useFetchHandler(serviceId, panelId, env, deploymentSource);
    useContextHandlers(serviceId, deploymentSource, env);
    var now = useRef(Date.now());
    useEffect(function () {
        now.current = Date.now();
    }, []);
    if (deploymentSource === "local" && env.includes("prod")) {
        return (React.createElement(CenteredMessage, null, "You are allowed to turn on local development mode only on non-production environments."));
    }
    return (React.createElement(React.Fragment, null,
        loadStatus === "loading" && React.createElement(Spinner, null),
        loadStatus === "failed" && (React.createElement(CenteredMessage, null, failMessage(panelId, deploymentSource))),
        React.createElement(IFrame, { title: "Panel Content", hidden: loadStatus === "loading" || loadStatus === "failed", frameBorder: 0, src: panelUrl + "?t=" + now.current, sandbox: iframePolicies, allow: "clipboard-write" })));
};
var templateObject_1;
